import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=036aefd8&scoped=true&"
import script from "./BaseRadio.js?vue&type=script&lang=js&"
export * from "./BaseRadio.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=036aefd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036aefd8",
  null
  
)

export default component.exports